export default function FilterVideos() {
    const filterForm = $('.filter__form');

    if (filterForm.length > 0) {
        const filterElements = {
            form: filterForm,
            btn: $('.c-filter li button'),
            filter: $('.c-filter [data-video-filter]'),
            input: {
                cat: filterForm.find('input[name="cat"]'),
                functions: filterForm.find('input[name="functions"]'),
            }
        };

        filterElements.form.submit(function (e) {
            e.preventDefault();

            const catValue = filterElements.input.cat.val();
            const functionsValue = filterElements.input.functions.val();

            $('.c-filter__item').hide();

            let anyResults = false;
            $('.c-filter__item').each(function () {
                const $this = $(this);
                const hasCatClass = catValue === '' || $this.hasClass(catValue);
                const hasFunctionsClass = functionsValue === '' || $this.hasClass(functionsValue);

                if (hasCatClass && hasFunctionsClass) {
                    $this.show();
                    anyResults = true;
                }
            });

            $('#noResultsMessage').toggle(!anyResults);
        });

        filterElements.btn.click(function () {
            const $value = $(this).attr('data-video-filter');
            const $filterType = $(this).attr('name');

            const $list = $(this).closest('.c-filter').find('li');

            $list.removeClass('isActive');
            $(this).closest('li').addClass('isActive');
            filterElements.input[$filterType].val($value);

            filterElements.form.submit();
        });
    }
}
